import { Button, Form, Input } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { addNetworksRequest } from '../../../store/actions/networks';
import styles from '../index.module.css';

const NetworksAdd = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();

  const isLoading = useSelector((state) => state.networks.loading);

  const handleFinish = (values) => {
    dispatch(
      addNetworksRequest({
        body: values,
        redirection: () => {
          history.push('/admin/networks');
        },
      })
    );
  };

  return (
    <div
      className={
        styles['admin-content'] +
        ' ' +
        styles['network-content'] +
        ' ' +
        styles['network-content']
      }
    >
      <div className={styles.table__header}>
        <h3 className={styles.table__title}>{t('admin.networks.add.title')}</h3>
      </div>
      <div className={styles.form__container}>
        <Form layout='vertical' name='network-edit' onFinish={handleFinish}>
          <Form.Item
            name='name'
            label={t('admin.networks.add.label.name')}
            rules={[
              {
                required: true,
                message: t('admin.networks.add.validation.name'),
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name='vlan'
            label={t('admin.networks.add.label.vlan')}
            rules={[
              {
                required: true,
                message: t('admin.networks.add.validation.vlan'),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='mac'
            label={t('admin.networks.add.label.mac')}
            rules={[
              {
                required: true,
                message: t('admin.networks.add.validation.mac'),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='comments'
            label={t('admin.networks.add.label.comments')}
          >
            <Input />
          </Form.Item>

          <div className={styles.buttons__container}>
            <Link to={'/admin/networks'}>
              <Button type='link' size='large'>
                {t('admin.networks.add.button.cancel')}
              </Button>
            </Link>
            <Button
              type='primary'
              htmlType='submit'
              size='large'
              loading={isLoading ? true : false}
            >
              {t('admin.networks.add.button.submit')}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default NetworksAdd;
